import React from 'react';
import UsersView from './UsersView';
const Jobs = () => {
    return (
        <UsersView />
    )
}
export default Jobs;